import { EntityType } from 'app/shared/model/enumerations/entity-type.model';

export interface IEntityAttribute {
  id?: string;
  entityType?: keyof typeof EntityType;
  entityId?: string;
  name?: string;
  value?: string;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  sortOrder?: number;
  parent?: IEntityAttribute | null;
}

export const defaultValue: Readonly<IEntityAttribute> = {
  active: false,
};
